import type { CommandHandler } from '../types';

export const importSubscriptionProofBankStatementCommandHandler: CommandHandler = (
  command,
  context
) => {
  if (!context.metadata.contentKey) {
    return { success: false, error: 'Grid context is not available.' };
  }

  if (!context.openSubscriptionProofBankImportDialog) {
    return { success: false, error: 'Bank statement import is not available.' };
  }

  context.openSubscriptionProofBankImportDialog(command);
  return { success: true };
};
